import { NavLink } from "react-router-dom";
import Breadcrumb from "./Breadcrumb";
import Container from "./Container";
import Header from "./Header";
import Sidebar from "./Sidebar";

const Layout = ({ children }: { children: any }) => {
  // const [collapsed, setCollapsed] = useState(() => {
  // const storedState = localStorage.getItem("collapsed");
  // return storedState !== null ? JSON.parse(storedState) : false;
  // });

  // Update localStorage whenever collapsed state changes
  // useEffect(() => {
  //   localStorage.setItem("collapsed", JSON.stringify(collapsed));
  // }, [collapsed]);
  return (
    <>
      <div className="bg-[#f5f8fa]">
        <div className="flex h-screen w-full">
          <div className="shrink-0 h-screen bg-[#2e66c0]">
            <Sidebar />
          </div>
          <div className={`w-[calc(100%_-_84px)] relative`}>
            <div className="py-1 bg-white mb-3 relative shadow-lg">
              <Header />
              <div className="absolute inset-x-0 bottom-0 h-1 shadow-sm"></div>
            </div>
            <div className="">
              <div className="flex flex-col overflow-y-auto h-[calc(90vh_-_20px)] px-3">
                {children}
              </div>
              <div className="py-2 w-full flex justify-center bg-white absolute bottom-0 left-0 right-0 text-sm">
                <div>
                  Copyright © 2024 | Powered by{" "}
                  <NavLink
                    to="https://cybernativetech.com/"
                    style={{ color: "blue" }}
                    target="_blank"
                  >
                    Cybernative Technologies Pvt. Ltd.
                  </NavLink>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { Breadcrumb, Container };
export default Layout;
